import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actions as accountActions } from "../../modules/account"
import { actions as userActions } from "../../modules/user"
import { actions as dataActions } from "../../modules/data"
import { withRouter } from "react-router-dom"

// ToDo: Find a better alternative for passing the location than withRouter

import EventLayout from "./"

const mapDispatchToProps = dispatch => {
  const actions = {
    logout: accountActions.logout,
    getUser: userActions.getUser,
    clearUser: userActions.clearUser,
    getOrganization: dataActions.getPublicOrganization,
  }

  return bindActionCreators(actions, dispatch)
}

const mapStateToProps = ({
  account,
  user,
  process,
  routing,
  data,
  candidate,
}) => ({
  logoutLoading: account.loading,
  account: account,
  organization: data.organization,
  role: candidate && candidate.role && candidate.role.name,
  process: process,
  location: routing.location,
  user: user ? user : {},
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventLayout)
)
